import React, {useContext, useEffect, useState} from 'react';
import { NotificationManager } from 'react-notifications';
import { useHistory } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import moment from "moment";
import 'moment/min/locales';
import {normalizeLanguage} from '../utils';

import connection from '../connection';

const AuthProvider = props => {
  const [data, setData] = useState({ user: null, checked: false });
  const history = useHistory()
  const { i18n, t } = useTranslation();

  useEffect(() => {
    (async () => {
      if (data.user) {
        const language = normalizeLanguage(data.user.language || i18n.resolvedLanguage || i18n.language);
        await i18n.changeLanguage(language);
        moment.locale(language);
      }
    })()
  }, [data.user]);

  function addActiveLeague(user) {
    let url_str = window.location.href;
    let url = new URL(url_str);

    if (url.searchParams.get("league_id") != null) {
      user.active_enrollment = {
        league_category_id: url.searchParams.get("league_category_id"),
        league_division_id: url.searchParams.get("league_division_id"),
        league_edition_id: url.searchParams.get("league_edition_id"),
        league_id: url.searchParams.get("league_id"),
        welcome_pack_needed: url.searchParams.get("welcome_pack_needed"),
        welcomepack_location: url.searchParams.get("welcomepack_location"),
        enrollment_id: url.searchParams.get("enrollment_id")
      };
    } else {
      user.active_enrollment = user.enrollments[0];
    }

    return user;
  }

  const changeEnrollment = (user, enrollment) => {
    user.active_enrollment = enrollment;
    setData({ ...data, user: user, checked: true });
  }

  const login = async (email, password, callback) => {
    try {
      const auxUser = await connection.post('v1/auth/sign_in', {
        email,
        password
      });

      setData({ ...data, user: addActiveLeague(auxUser.data) });
      callback && callback();
    } catch (e) {
      if (e?.data?.errors) {
        const error = e.data.errors[0] !== '' ? e.data.errors[0] : t('login_page.errors.invalid_credentials');
        NotificationManager.error(error, t("common.error"), 4000);
      } else {
        NotificationManager.error(t('login_page.errors.invalid_credentials'), t("common.error"), 4000);
      }
    }
  }

  const logout = async () => {
    await connection.delete('v1/auth/sign_out');
    history.push("/login")
    setData({user: null, checked: false});
  }

  const setUser = user => {
    setData({...data, user: addActiveLeague(user)});
  }

  (async () => {
    if (!data.checked) {
      try {
        const aux = await connection.get('v1/auth/validate_token');
        setData({ ...data, user: addActiveLeague(aux.data), checked: true });
      } catch (e) {
        setData({ ...data, checked: true });
      }
    }
  })();

  return (
     <AuthContext.Provider
        value={{ login, logout, user: data.user, checked: data.checked, setUser, changeEnrollment }}
        {...props}
     />
  );
};

const withAuth = Component => {
  return class extends React.Component {
    render() {
      return (
         <AuthContext.Consumer>
           {(props) => <Component {...props} {...this.props}/>}
         </AuthContext.Consumer>
      );
    }
  };
};

const AuthContext = React.createContext({})

const useAuth = () => useContext(AuthContext)

export {AuthProvider, AuthContext, useAuth, withAuth}
